import React from 'react';
import { View, Pressable, Text, StyleSheet } from 'react-native';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import CampsListView from '../../../explore_screen/components/views/CampsListView';
import SessionsTableView from '../session/SessionsTableView';

interface SessionsViewSectionProps {
    sessions: any;
    sessionsViewMode: 'cards' | 'table';
    setSessionsViewMode: (mode: 'cards' | 'table') => void;
    showPastSessions: boolean;
    setShowPastSessions: (value: boolean) => void;
    canEdit: boolean;
    isHost: boolean;
    camp: any;
    addSession: () => void;
    setSessions: (sessions: any) => void;
    urlViewType?: 'comments' | 'photos' | null;
    urlDate?: string | null;
    sessionIdFromUrl?: string | null;
    shouldOpenCamperView?: boolean;
}

const SessionsViewSection: React.FC<SessionsViewSectionProps> = ({
    sessions,
    sessionsViewMode,
    setSessionsViewMode,
    showPastSessions,
    setShowPastSessions,
    canEdit,
    isHost,
    camp,
    addSession,
    setSessions,
    urlViewType,
    urlDate,
    sessionIdFromUrl,
    shouldOpenCamperView,
}) => {

    const hasSessions = Object.keys(sessions).length > 0;

    return (
        <View style={styles.sessionsContainer}>
            <View style={{ minHeight: 300, flex: 1, justifyContent: 'center' }}>
                <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: 12, paddingBottom: 16 }}>
                    {/* Only host can view all past sessions of a camp anyway. */}
                    {
                        isHost && <View style={styles.segmentedContainer}>
                            <Pressable
                                onPress={() => setShowPastSessions(false)}
                                style={({ pressed }) => ([
                                    styles.segmentedPill,
                                    !showPastSessions && styles.segmentedPillActive,
                                    pressed && !showPastSessions && { opacity: 0.95 }
                                ])}
                            >
                                <MaterialCommunityIcons name='calendar-clock' size={14} color={!showPastSessions ? 'white' : '#6B7280'} />
                                <Text style={[styles.segmentedText, !showPastSessions && styles.segmentedTextActive]}>Current</Text>
                            </Pressable>
                            <Pressable
                                onPress={() => setShowPastSessions(true)}
                                style={({ pressed }) => ([
                                    styles.segmentedPill,
                                    showPastSessions && styles.segmentedPillActive,
                                    pressed && showPastSessions && { opacity: 0.95 }
                                ])}
                            >
                                <MaterialCommunityIcons name='history' size={14} color={showPastSessions ? 'white' : '#6B7280'} />
                                <Text style={[styles.segmentedText, showPastSessions && styles.segmentedTextActive]}>Past</Text>
                            </Pressable>
                        </View>
                    }

                    {
                        hasSessions && <View style={[styles.segmentedContainer, { marginLeft: 12 }]}>
                            <Pressable
                                onPress={() => setSessionsViewMode('cards')}
                                style={({ pressed }) => ([
                                    styles.segmentedPill,
                                    sessionsViewMode === 'cards' && styles.segmentedPillActive,
                                    pressed && sessionsViewMode === 'cards' && { opacity: 0.95 }
                                ])}
                            >
                                <MaterialCommunityIcons name='view-list' size={14} color={sessionsViewMode === 'cards' ? 'white' : '#6B7280'} />
                                <Text style={[styles.segmentedText, sessionsViewMode === 'cards' && styles.segmentedTextActive]}>List</Text>
                            </Pressable>
                            <Pressable
                                onPress={() => setSessionsViewMode('table')}
                                style={({ pressed }) => ([
                                    styles.segmentedPill,
                                    sessionsViewMode === 'table' && styles.segmentedPillActive,
                                    pressed && sessionsViewMode === 'table' && { opacity: 0.95 }
                                ])}
                            >
                                <MaterialCommunityIcons name='table' size={14} color={sessionsViewMode === 'table' ? 'white' : '#6B7280'} />
                                <Text style={[styles.segmentedText, sessionsViewMode === 'table' && styles.segmentedTextActive]}>Table</Text>
                            </Pressable>
                        </View>
                    }
                </View>

                {
                    hasSessions
                        ? sessionsViewMode === 'cards'
                            ? <View style={{ flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                                {canEdit && (
                                    <View style={{ paddingRight: 20, paddingLeft: 10 }}>
                                        <Pressable
                                            style={({ pressed }) => ({
                                                width: 40,
                                                height: 40,
                                                borderRadius: 20,
                                                backgroundColor: pressed ? '#28A745' : '#34C759',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                shadowColor: '#000',
                                                shadowOffset: { width: 0, height: 2 },
                                                shadowOpacity: 0.15,
                                                shadowRadius: 3,
                                                elevation: 3,
                                            })}
                                            onPress={addSession}
                                        >
                                            <MaterialCommunityIcons name='plus' size={24} color='white' />
                                        </Pressable>
                                    </View>
                                )}

                                <View style={{ flex: 1, alignItems: 'center' }}>
                                    <CampsListView isEditing={canEdit} setSessions={setSessions}
                                        sessions={sessions} isSessionView={true} camps={null}
                                        campSessionPage={true} camp={camp} />
                                </View>
                            </View>
                            : <View style={{ width: '100%', alignItems: 'center' }}>
                                <SessionsTableView
                                    sessions={sessions}
                                    isEditing={canEdit}
                                    setSessions={setSessions}
                                    addSession={addSession}
                                    isHost={isHost}
                                    urlViewType={urlViewType}
                                    urlDate={urlDate}
                                    sessionIdFromUrl={sessionIdFromUrl}
                                    shouldOpenCamperView={shouldOpenCamperView}
                                    camp={camp}
                                />
                            </View>
                        : canEdit
                            ? <View style={{ alignItems: 'center', marginTop: 50 }}>
                                <Pressable
                                    style={({ pressed }) => ({
                                        width: 60,
                                        height: 60,
                                        borderRadius: 30,
                                        backgroundColor: pressed ? '#28A745' : '#34C759',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        shadowColor: '#000',
                                        shadowOffset: { width: 0, height: 2 },
                                        shadowOpacity: 0.15,
                                        shadowRadius: 3,
                                        elevation: 3,
                                    })}
                                    onPress={addSession}
                                >
                                    <MaterialCommunityIcons name='plus' size={32} color='white' />
                                </Pressable>
                                <Text style={{ fontSize: 16, fontWeight: "500", marginTop: 15, color: '#666' }}>
                                    Add your first session
                                </Text>
                            </View>
                            : <View style={{ alignItems: 'center' }}>
                                <Text style={{ fontSize: 16, fontWeight: "500" }}>
                                    This SnapCamp has yet to post any sessions.
                                </Text>
                            </View>
                }
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    sessionsContainer: {
        marginTop: 20,
    },
    segmentedContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#F3F4F6',
        borderRadius: 999,
        padding: 4,
        borderWidth: 1,
        borderColor: '#E5E7EB',
        shadowColor: '#000',
        shadowOpacity: 0.06,
        shadowRadius: 6,
        shadowOffset: { width: 0, height: 3 },
    },
    segmentedPill: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 12,
        paddingVertical: 8,
        borderRadius: 999,
        backgroundColor: 'transparent',
        marginHorizontal: 2,
    },
    segmentedPillActive: {
        backgroundColor: '#3C8248',
        shadowColor: '#3C8248',
        shadowOpacity: 0.2,
        shadowRadius: 6,
        shadowOffset: { width: 0, height: 2 },
    },
    segmentedText: {
        fontSize: 12,
        fontWeight: '700' as const,
        color: '#6B7280',
        marginLeft: 6,
    },
    segmentedTextActive: {
        color: 'white',
    },
});

export default SessionsViewSection;

